import { defineComponent as _defineComponent } from 'vue'
import { fetchTokenPriceChange } from "@/api/endpoints";
import { onMounted, ref } from "vue";

// interface
interface IPrices {
	"5m"?: number;
	"30m"?: number;
	"1h"?: number;
	"6h"?: number;
	"12h"?: number;
	"24h"?: number;
}

// dto
interface IProps {
	mint: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TokenPriceChange',
  props: {
    mint: null
  },
  setup(__props: any) {

const props = __props as {
	mint: string;
};

function PricesDTO(primitive: any): IPrices {
	const prices: IPrices = {};

	if (!primitive) return prices;

	prices["5m"] = primitive.minute_5?.change;
	prices["30m"] = primitive.minute_30?.change;
	prices["1h"] = primitive.hour_1?.change;
	prices["6h"] = primitive.hour_6?.change;
	prices["12h"] = primitive.hour_12?.change;
	prices["24h"] = primitive.hour_24?.change;

	return prices;
}

// props


// data
const loading = ref<boolean>(true);
const prices = ref<IPrices>({});

// methods
async function mounted() {
	prices.value = PricesDTO(await fetchTokenPriceChange(props.mint));
	loading.value = false;

	setTimeout(mounted, 60000);
}

// setup
onMounted(mounted);

return { __sfc: true,PricesDTO, props, loading, prices, mounted }
}

})